.button {
  border-radius: var(--mirai-finder-button-border-radius);
  font-family: var(--mirai-finder-button-font-family);
  font-size: var(--mirai-finder-button-font-size);
  font-weight: var(--mirai-finder-button-font-weight);
  height: var(--mirai-field-height);
  max-height: var(--mirai-field-height);
  min-height: var(--mirai-field-height);
}

.button:not(:hover) {
  background-color: var(--mirai-finder-button-background) !important;
  color: var(--mirai-finder-button-color) !important;
}

.button:hover {
  background-color: var(--mirai-finder-button-background-active) !important;
  color: var(--mirai-finder-button-color-active) !important;
}
